<template>
  <div class="box">
    <!-- 搜索 -->
    <div class="top_box">
      <img
        class="backImg"
        src="@/assets/home/black_back.png"
        @click="backToLast"
      />
      <search
        @inputChange="inputChange"
        @placeCity="placeCity"
        :city="city"
        :code="code"
        :isAlpha="false"
        placeHoder="请输入您想要搜索的内容"
        class="search_area"
      ></search>
    </div>
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerImages" :key="item">
        <img class="top_img" :src="item" />
      </van-swipe-item>
    </van-swipe>
    <div class="content_list">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="content_list_item"
      >
        <common-title
          :title="item.name"
          :hiddenBottomLine="true"
          :isShowMore="true"
          rightText="更多"
          rightColor="#333333"
          @lookMore="lookMore(item)"
        ></common-title>
        <div class="list_box">
          <div
            v-for="(value, i) in item.list"
            :key="i"
            class="list_item"
            @click="toDetail(value)"
          >
            <img
              :src="getFilePath(value.resourceRestaurantDTO.filePath)"
              class="img"
            />
            <div class="title">
              {{ value.resourceRestaurantDTO.restaurantName }}
            </div>
            <div class="position"></div>
          </div>
        </div>
      </div>
      <van-empty v-if="dataList.length == 0" description="暂无产品" />
    </div>
  </div>
</template>

<script>
import commonTitle from "../../components/common_title.vue";
import search from "../home/components/search.vue";
import { getImgUrl } from "@/mixins/getImgUrl";
import { getFilePath } from "../../utils";
export default {
  components: {
    search,
    commonTitle,
  },
  mixins: [getImgUrl],
  data() {
    return {
      bannerImages: [
        require("../../assets/restaurant-banner1.jpeg"),
        require("../../assets/restaurant-banner2.jpeg"),
        require("../../assets/restaurant-banner3.jpeg"),
      ],
      dataList: [],
      list: [],
      categoryList: [],
      search: "",
      playCity: "",
      city: "城市",
      code: "",
    };
  },
  methods: {
    placeCity(item) {
      this.playCity = item;
      this.init();
    },
    inputChange(value) {
      this.search = value;
      this.init();
    },
    backToLast() {
      this.$router.go(-1);
    },
    lookMore(item) {
      this.$router.push({
        path: "/restaurant/restaurantCategoryDetail",
        query: { productType: item.categoryId },
      });
    },
    getCategoryString(restaurantType) {
      for (let index = 0; index < this.categoryList.length; index++) {
        const e = this.categoryList[index];
        if (e.id == restaurantType) {
          return e.name;
        }
      }
    },
    queryCategoryList() {
      var params = {
        pagNum: 0,
        pagSize: 100,
      };
      this.$API.z_product.queryCategoryList(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.categoryList = res.rows;
          this.init();
        }
      });
    },
    init() {
      var params = {
        pageNum: 1,
        pageSize: 50,
        searchValues: this.search,
        playCity: this.playCity,
      };
      this.$API.z_product.getCateringGoodsForOrder(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.list = res.rows;
          var cList = [];
          for (let index = 0; index < this.categoryList.length; index++) {
            const e = this.categoryList[index];
            var pList = [];
            for (let i = 0; i < this.list.length; i++) {
              const element = this.list[i];
              const item = element.list[0];
              if (item.categoryId == e.id) {
                pList.push(element);
              }
            }
            var tempP = {
              name: e.name,
              categoryId: e.id,
              list: pList,
            };
            if (pList.length > 0) {
              cList.push(tempP);
            }
          }
          this.dataList = cList;
        }
      });
    },
    toDetail(value) {
      this.$router.push({
        path: "/restaurant/restaurantDetail",
        query: { ID: value.resourceRestaurantDTO.id },
      });
    },
  },
  mounted() {
    this.queryCategoryList();
    var cityItem = JSON.parse(sessionStorage.getItem("city"));
    if (cityItem) {
      this.city = cityItem[1].name;
      this.code = cityItem[1].code;
      this.playCity = this.city == "全国" ? "" : cityItem[1].code;
    }
    // this.init();
  },
};
</script>

<style lang="scss" scoped>
.box {
  .top_box {
    position: absolute;
    top: vw(20);
    left: vw(30);
    right: vw(30);
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: 2;
    .backImg {
      width: vw(28);
      height: vw(28);
    }
    .search_area {
      background-color: #f7f8fa;
      margin-left: vw(30);
      height: vw(72);
      border-radius: vw(36);
      flex: 1;
    }
  }
  .top_img {
    width: 100%;
    height: vw(600);
    object-fit: cover;
  }
  .content_list {
    position: relative;
    margin-top: vw(-32);
    padding-bottom: vw(50);
    border-top-left-radius: vw(32);
    border-top-right-radius: vw(32);
    background-color: #ffffff;
    .content_list_item {
      margin-bottom: vw(30);
      //去除div滚动条
      .list_box::-webkit-scrollbar {
        display: none;
      }
      .list_box {
        overflow-x: auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        .list_item {
          margin-left: vw(30);
          .img {
            width: vw(280);
            height: vw(160);
            border-radius: vw(8);
            // background-color: red;
          }
          .title {
            width: vw(280);
            margin-top: vw(12);
            color: #333333;
            font-size: vw(28);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .position {
            margin-top: vw(5);
            color: #999999;
            font-size: vw(24);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
